// extracted by mini-css-extract-plugin
module.exports = {"containerSpacing":"Sponsorship_containerSpacing__4t9c4"};